export class Feriado {
  id: number;
  descricao: string;
  data: Date;
}
